// extracted by mini-css-extract-plugin
export default {"backdropLoader":"ModalContainer_backdropLoader__JxKDj"};